import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem } from '~/views'
import style from './style.css'

export default class BlueprintItem extends React.Component {
  
  static SIMULATE_EVENT = 'simulateBlueprint'

  static EXPORT_RAW = 'exportRawBlueprint'

  static EXPORT_SPEC = 'exportSpecBlueprint'

  static EDIT_ATTRIBUTES_EVENT = 'editAttributes'

  static CREATE_SCENARIO = 'createScenario'

  static REMOVE_EVENT = 'removeBlueprint'

  static TRANSFER_EVENT = 'transferBlueprint'

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const bp = this.props.item;
    return (
      <ListItem className={style.blueprintItem}
        selected={this.props.selected}
        onEvent={this.props.onEvent}
        item={bp}
        title={bp.name}
        subtitle={moment( bp.lastModified ).fromNow()}
        leftView={this.renderLeft( bp )}
        rightView={this.renderRight()} />
    )
  }

  renderLeft( bp ) {
    if ( bp.purpose === 'organization' ) {
      return (
        <span className={classnames( style.orgIcon )}>
          <i className="fa fa-object-group" />
        </span>
      )
    }
    return (
      <span className={classnames( style.devIcon )}>
        <i className="fa fa-microchip" />
      </span>
    )

  }

  renderRight() {

    return (
      <DropdownButton pullRight bsStyle="link" title={<i className="fa-fw fa-lg fa-gear" />} key={this.props.item.id} id={`options-${this.props.item.id}`}>
        <MenuItem bsStyle="link"
          bsSize="large" 
          onClick={() => { this.onEvent( BlueprintItem.SIMULATE_EVENT ) }}> 
          <i className="fa fa-play-circle fa-fw" />
          {' '}
          Start Simulator
        </MenuItem>
        <MenuItem bsStyle="link"
          bsSize="large" 
          onClick={() => { this.onEvent( BlueprintItem.CREATE_SCENARIO ) }}> 
          <i className="fa fa-film fa-fw" />
          {' '}
          Create Scenario
        </MenuItem>
        <MenuItem divider />
        <MenuItem bsStyle="link"
          bsSize="large" 
          onClick={() => { this.onEvent( BlueprintItem.EXPORT_RAW ) }}> 
          <i className="fa fa-download fa-fw" />
          {' '}
          Export
        </MenuItem>
        {/* }
        <MenuItem bsStyle="link" bsSize="large" 
                onClick={()=>{this.onEvent( BlueprintItem.EXPORT_SPEC )}} > 
          <i className="fa fa-table fa-fw"></i> View Specification
        </MenuItem>
        <MenuItem bsStyle="link" bsSize="large" className={style.pause} 
           onClick={()=>{this.onEvent( BlueprintItem.TRANSFER_EVENT )}} > 
          <i className="fa fa-paper-plane-o fa-fw"></i> Transfer
        </MenuItem>
      */}
        <MenuItem divider />
        <MenuItem bsStyle="link"
          bsSize="large" 
          onClick={() => { this.onEvent( BlueprintItem.REMOVE_EVENT ) }}> 
          <i className="fa fa-times-circle fa-fw" />
          {' '}
          Delete
        </MenuItem>
      </DropdownButton>
    )
  }

}
